<template>
    <div class="p-3">
        <h3>RL 3.18 Rekapitulasi Kegiatan Pelayanan Farmasi Rumah Sakit - Resep</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Rekapitulasi Kegiatan Pelayanan Farmasi Rumah Sakit - Resep"
            :filter-configs="filterConfigs" :table-options="tableOptions" :show-filter="true" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'start_date',
                    label: 'Tanggal Awal',
                    field: 'start_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
                {
                    id: 'end_date',
                    label: 'Tanggal Akhir',
                    field: 'end_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
            ],
            tableOptions: {
                baseUrl: '/api/rekapitulasi-pelayanan/kegiatan-penjualan-obat',
                layout: 'fitData',
                responsiveLayout: 'collapse',
                columns: [
                    {
                        title: "No.",
                        field: "no",
                        hozAlign: "center",

                    },
                    {
                        title: "Golongan Obat",
                        field: "golongan_obat",
                    },
                    {
                        title: "Rawat Jalan",
                        field: "rajal",
                        hozAlign: "right",
                    },
                    {
                        title: "IGD",
                        field: "igd",
                        hozAlign: "right",
                    },
                    {
                        title: "Rawat Inap",
                        field: "ranap",
                        hozAlign: "right",
                    },
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
